import { FppFilterSettings } from "@/features/search-filter/types/FppFilterSettings";

export const statisticsByCustomerFilterSettings: FppFilterSettings = {
  sellerEnabled: true,
  routePairEnabled: true,
  routePairHeader: "Routes",
  negotiationStatusEnabled: true,
  salesRegionEnabled: true,
};
